<span>
  <button
    [disabled]="isReadOnly"
    (click)="onEditClicked()"
    mat-icon-button
    [matTooltip]="'DEMAND_REQUEST.DETAIL.PRODUCTS.GRID.EDIT.TOOLTIP' | translate"
  >
    <mat-icon>edit</mat-icon>
  </button>
  <button
    [disabled]="isReadOnly"
    (click)="onDeleteClicked()"
    mat-icon-button
    [matTooltip]="'DEMAND_REQUEST.DETAIL.PRODUCTS.GRID.DELETE.TOOLTIP' | translate"
  >
    <mat-icon>delete</mat-icon>
  </button>
  <button
    [disabled]="isReadOnly"
    (click)="onCloneClicked()"
    mat-icon-button
    [matTooltip]="'DEMAND_REQUEST.DETAIL.PRODUCTS.GRID.CLONE.TOOLTIP' | translate"
  >
    <mat-icon>content_copy</mat-icon>
  </button>
</span>
